import { FC } from "react";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { CoverImage } from "@/components";
import Image from "@/assets/cover/precision_game_cover.webp";
import PrecisionGameUI from "@/features/precisionGame/components/precision.game.ui";
import DateObject from "react-date-object";
import i18next from "i18next";

const PrecisionGame: FC = (): JSX.Element => {
  // Page Document Title
  useDocumentTitle("Test Your Precision");
  const timestamp = new DateObject().format("YYYY-MM-DD");

  return (
    <>
      <CoverImage
        src={Image}
        alt="CoverImage"
        heading={i18next.t("precisionGame.headline")}
        desc={i18next.t("precisionGame.objective", { objective: "1337" })}
      />
      <PrecisionGameUI
        collection={timestamp}
        winners={i18next.t("precisionGame.leaderboard.headline")}
        mentions={i18next.t("precisionGame.honorable.headline")}
      />
    </>
  );
};

export default PrecisionGame;
